<template>
    <div class="homestay__store knowledge-base__store">

        <div class="homestay__store-form-wrapper">
            <form action="#" class="homestay__store-form knowledge-base__store-form knowledge-base__store-form--open">

                <fieldset class="homestay__store-fieldset knowledge-base__store-fieldset d-flex">

                    <div class="homestay__store-fieldset-item knowledge-base__store-fieldset-item" style="position:relative;">
                        <input type="text" v-model="storeForm.citySearch" class="homestay__store-input knowledge-base__store-input" :placeholder="$store.getters.t('homestays_store_form_city')">
                        <div class="search-result search-result-store" v-if="storeForm.cities.length">
                            <div class="city-item" v-for="city in storeForm.cities" @click="setStoreCityId(city.id, city.name)">{{ city.name }}</div>
                        </div>
                        <div class="search-result search-result-store" v-if="!storeForm.cities.length && storeForm.citySearch && storeForm.citySearch !== storeForm.citySelected">
                            <div class="city-item">{{$store.getters.t('homestays_store_form_nothing_found')}}</div>
                        </div>
                        <div class="field-error-text" v-if="$v.storeForm.selectedCityId.$error">{{$store.getters.t('homestays_store_form_choose_city')}}</div>
                    </div>

                    <div class="homestay__store-fieldset-item knowledge-base__store-fieldset-item">
                        <input type="text" class="homestay__store-input knowledge-base__store-input" v-model="$v.storeForm.streetAddress.$model" :placeholder="$store.getters.t('homestays_store_form_street')">
                        <div class="field-error-text" v-if="$v.storeForm.streetAddress.$error">{{$store.getters.t('homestays_store_form_enter_street')}}</div>
                    </div>


                </fieldset>

                <fieldset class="homestay__store-fieldset knowledge-base__store-fieldset d-flex">

                    <div class="homestay__store-fieldset-item knowledge-base__store-fieldset-item">
                        <input type="text" class="homestay__store-input knowledge-base__store-input" v-model="$v.storeForm.title.$model" :placeholder="$store.getters.t('homestays_store_form_title')">
                        <div class="field-error-text" v-if="$v.storeForm.title.$error">{{$store.getters.t('homestays_store_form_enter_title')}}</div>
                    </div>

                </fieldset>

                <fieldset class="homestay__store-fieldset knowledge-base__store-fieldset d-flex">

                    <div class="homestay__store-fieldset-item knowledge-base__store-fieldset-item">
                        <textarea type="text" class="homestay__store-input knowledge-base__store-input" v-model="$v.storeForm.description.$model" :placeholder="$store.getters.t('homestays_store_form_description')"></textarea>
                        <div class="field-error-text" v-if="$v.storeForm.description.$error">{{$store.getters.t('homestays_store_form_description_min')}}</div>
                    </div>

                </fieldset>


                <fieldset class="homestay__store-fieldset knowledge-base__store-fieldset knowledge-base__store-fieldset--wrapped d-flex" v-if="petsCategories.length">
                    <p class="homestay__store-fieldset-item knowledge-base__store-fieldset-item knowledge-base__store-fieldset-item--full-width">{{$store.getters.t('homestays_store_form_pet_categories')}}</p>
                    <div class="homestay__store-fieldset-item knowledge-base__store-fieldset-item">
                        <div class="custom_checkbox" v-for="(category, idx) in petsCategories">
                            <input type="checkbox"
                                   :id="'category_' + category.code"
                                   name="petCategories[]"
                                   :value="category.id"
                                   v-model="$v.storeForm.petCategories.$model">

                            <label :for="'category_' + category.code">
                                <span class="shadow_checkbox"></span>
                                <span class="radio_title">{{ category.name }}</span>
                            </label>
                        </div>
                        <div class="field-error-text" v-if="$v.storeForm.petCategories.$error">{{$store.getters.t('homestays_store_form_enter_category')}}</div>
                    </div>
                </fieldset>

                <fieldset class="homestay__store-fieldset knowledge-base__store-fieldset d-flex">

                    <div class="homestay__store-fieldset-item knowledge-base__store-fieldset-item">
                        <p class="homestay__store-label knowledge-base__store-label">{{$store.getters.t('homestays_store_form_pricing')}}</p>
                        <div class="custom-radio">
                            <input type="radio" id="charge_free" v-model="$v.storeForm.chargeCategory.$model" value="free" name="charge">
                            <label for="charge_free">
                                <span class="circle"></span>
                                {{$store.getters.t('homestays_store_form_free')}}
                            </label>
                        </div>
                        <div class="custom-radio">
                            <input type="radio" id="charge_paid" v-model="$v.storeForm.chargeCategory.$model" value="paid_for" name="charge">
                            <label for="charge_paid">
                                <span class="circle"></span>
                                {{$store.getters.t('homestays_store_form_paid')}}
                            </label>
                        </div>
                        <div class="field-error-text" v-if="$v.storeForm.chargeCategory.$error">{{$store.getters.t('homestays_store_form_choose_tariff')}}</div>
                    </div>

                    <div class="homestay__store-fieldset-item knowledge-base__store-fieldset-item">
                        <p class="homestay__store-label knowledge-base__store-label">{{$store.getters.t('homestays_store_form_reception')}}</p>
                        <div class="custom-radio">
                            <input type="radio" id="reception_open" v-model="$v.storeForm.receptionStatus.$model" value="open" name="reception">
                            <label for="reception_open">
                                <span class="circle"></span>
                                {{$store.getters.t('homestays_store_form_reception_open')}}
                            </label>
                        </div>
                        <div class="custom-radio">
                            <input type="radio" id="reception_closed" v-model="$v.storeForm.receptionStatus.$model" value="closed" name="reception">
                            <label for="reception_closed">
                                <span class="circle"></span>
                                {{$store.getters.t('homestays_store_form_reception_closed')}}
                            </label>
                        </div>
                        <div class="field-error-text" v-if="$v.storeForm.receptionStatus.$error">{{$store.getters.t('homestays_store_form_enter_status')}}</div>
                    </div>


                </fieldset>

                <fieldset class="homestay__store-fieldset knowledge-base__store-fieldset d-flex">
                    <div class="homestay__store-fieldset-item knowledge-base__store-fieldset-item">
                        <p class="homestay__store-label knowledge-base__store-label">{{$store.getters.t('homestays_store_form_type')}}</p>
                        <div class="custom-radio">
                            <input type="radio" id="type_apartment" v-model="$v.storeForm.type.$model" value="apartment" name="type">
                            <label for="type_apartment">
                                <span class="circle"></span>
                                {{$store.getters.t('homestays_store_form_type_apartment')}}
                            </label>
                        </div>
                        <div class="custom-radio">
                            <input type="radio" id="type_enclosure" v-model="$v.storeForm.type.$model" value="enclosure" name="type">
                            <label for="type_enclosure">
                                <span class="circle"></span>
                                {{$store.getters.t('homestays_store_form_type_enclosure')}}
                            </label>
                        </div>
                        <div class="field-error-text" v-if="$v.storeForm.type.$error">{{$store.getters.t('homestays_store_form_enter_type')}}</div>
                    </div>

                    <div class="homestay__store-fieldset-item knowledge-base__store-fieldset-item">
                        <p class="homestay__store-label knowledge-base__store-label">{{$store.getters.t('homestays_store_form_view_mode')}}</p>
                        <div class="custom-radio">
                            <input type="radio" id="view_mode_homestay" v-model="$v.storeForm.viewMode.$model" value="homestay" name="view_mode">
                            <label for="view_mode_homestay">
                                <span class="circle"></span>
                                {{$store.getters.t('homestays_store_form_view_mode_homestay')}}
                            </label>
                        </div>
                        <div class="custom-radio">
                            <input type="radio" id="view_mode_user" v-model="$v.storeForm.viewMode.$model" value="user" name="view_mode">
                            <label for="view_mode_user">
                                <span class="circle"></span>
                                {{$store.getters.t('homestays_store_form_view_mode_user')}}
                            </label>
                        </div>
                        <div class="field-error-text" v-if="$v.storeForm.viewMode.$error">{{$store.getters.t('homestays_store_form_enter_view_mode')}}</div>
                    </div>


                </fieldset>

                <fieldset class="homestay__store-fieldset  knowledge-base__store-fieldset d-flex">

                    <div class="homestay__store-fieldset-item knowledge-base__store-fieldset-item knowledge-base__store-fieldset-item--halfs d-flex">
                        <p class="homestay__store-label knowledge-base__store-label">{{$store.getters.t('homestays_store_form_days_count')}}</p>
                        <input type="number" id="min_duration" v-model="$v.storeForm.min_duration.$model" name="min_duration" :placeholder="$store.getters.t('homestays_store_form_from')">
                        <input type="number" id="max_duration" v-model="$v.storeForm.max_duration.$model" :placeholder="$store.getters.t('homestays_store_form_to')" name="max_duration">

                        <div class="field-error-text" v-if="$v.storeForm.min_duration.$error">{{$store.getters.t('homestays_store_form_enter_min_days')}}</div>
                        <div class="field-error-text" v-if="$v.storeForm.max_duration.$error">{{$store.getters.t('homestays_store_form_max_less_min')}}</div>

                    </div>

                </fieldset>

                <fieldset class="homestay__store-fieldset knowledge-base__store-fieldset d-flex">

                    <div class="homestay__store-fieldset-item knowledge-base__store-fieldset-item">
                        <div class="upload_wrapper">
                            <div class="row text-center">

                                <div class="col-12 col-md-6">
                                    <div class="custom_upload">
                                        <label for="screenshot">
                                            <input type="file" id="screenshot" name="photos" class="files w-100" accept=".png,.jpeg,.jpg,.gif"
                                                   @change="handleFileUpload" multiple>
                                            <span class="btn">{{$store.getters.t('homestays_store_form_choose_photos')}}</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="col-12 col-md-6" v-if="updateOBJ">
                                    <button type="submit" @click.prevent="storePost" class="btn"
                                            :style="{backgroundColor: storeFormStatus.color}"
                                            :disabled="storeStatus === 'pending'">{{ storeFormStatus.text }}
                                    </button>
                                </div>
                                <div class="col-12 col-md-6" v-else>
                                    <button type="submit" @click.prevent="storePost" class="btn"
                                            :style="{backgroundColor: storeFormStatus.color}"
                                            :disabled="storeStatus === 'pending'">{{ storeFormStatus.text }}
                                    </button>
                                </div>

                            </div>
                        </div>

                        <template v-if="type === 'UPDATE' && serverImages.length">
                            <div class="row mt-4 update-image">
                                <div class="col-md-12">
                                    <p>{{$store.getters.t('homestays_store_form_photos_already_uploaded')}}</p>
                                </div>
                                <div class="col-6 col-sm-4 col-md-3" v-for="(image, idx) in serverImages">
                                    <div class="row">
                                        <div class="col-12">
                                            <img :src="`/storage${image.path.replace('original', 'preview_l')}`" alt="" class="w-100">
                                            <span class="lnr upload_cross lnr-cross" style="cursor:pointer;" @click="deleteServerPhoto(idx, image.id)"></span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </template>

                        <template v-if="storeForm.previewImages.length">

                            <div class="row mt-4 update-image" v-for="(image, index) in storeForm.previewImages">
                                <div class="col-5 col-md-3">
                                    <img :src="image.base64" alt="" class="w-100">
                                    <span class="lnr upload_cross lnr-cross" style="cursor:pointer;" @click="deletePhoto(index)"></span>
                                </div>
                                <div class="col-7 col-md-9" style="word-break: break-word;">
                                    {{ image.name }}
                                </div>
                            </div>
                        </template>


                    </div>
                </fieldset>


            </form>
        </div>

    </div>
</template>

<script>

import {required, numeric, minValue, maxLength, minLength} from 'vuelidate/lib/validators';

export default {
    name: "StoreForm",
    props: ['type', 'updateOBJ', 'pets'],
    data() {
        return {
            appRoutes: null,
            petsCategories: [],
            storeStatus: 'waiting_to_send',
            storeForm: {
                citySearch: null,
                citySelected: null,
                selectedCityId: null,
                cities: [],

                viewMode: null,
                type: null,
                min_duration: 1,
                max_duration: null,
                streetAddress: null,
                title: null,
                description: null,
                petCategories: [],
                chargeCategory: null,
                receptionStatus: null,

                deleteImagesIds: [],

                previewImagesOnlyBase64: [],
                previewImages: [],
                images: [],
            },

            serverImages: []
        }
    },

    created() {
        this.appRoutes = window.appRoutes;
    },

    mounted() {
        if ((this.type === 'UPDATE' && Object.keys(this.updateOBJ).length)) {

            this.petsCategories = this.pets

            this.storeForm = {
                citySearch: this.updateOBJ.city.name || null,
                citySelected: this.updateOBJ.city.name || null,
                selectedCityId: this.updateOBJ.city.id || null,
                cities: [],

                viewMode: this.updateOBJ.view_mode || null,
                type: this.updateOBJ.type || null,
                min_duration: this.updateOBJ.min_duration || 1,
                max_duration: this.updateOBJ.max_duration || null,
                streetAddress: this.updateOBJ.street_address || null,
                title: this.updateOBJ.name || null,
                description: this.updateOBJ.description || null,

                petCategories: this.updateOBJ.pet_categories ? (this.updateOBJ.pet_categories.map(a => a.id)) : [],
                chargeCategory: this.updateOBJ.charge_category || null,
                receptionStatus: this.updateOBJ.reception_status || null,

                deleteImagesIds: [],

                previewImagesOnlyBase64: [],
                previewImages: [],
                images: [],
            }


            this.serverImages = this.updateOBJ.images || []


            return

        }


        this.getPetsCategories()

    },

    watch: {

        'storeForm.citySearch': function (value) {
            if (!value) {
                this.storeForm.citySelected = null;
                this.storeForm.cities = [];
                this.storeForm.selectedCityId = null;
                return false;
            }

            if (value !== this.storeForm.citySelected) {
                this.searchCities(true);
            }
        },

        'storeForm.images': function () {
            let self = this;

            if (self.noReloadPreview) {
                self.noReloadPreview = false;
                return false
            }

            self.storeForm.images.forEach(function (image) {
                if (typeof FileReader === "function") {
                    const reader = new FileReader();

                    reader.onload = event => {
                        if ($.inArray(event.target.result, self.storeForm.previewImagesOnlyBase64) === -1) {
                            self.storeForm.previewImages.push({
                                'base64': event.target.result,
                                'name': image.name,
                            });
                            self.storeForm.previewImagesOnlyBase64.push(event.target.result);
                        }
                    };

                    reader.readAsDataURL(image);
                }
            });
        },
    },

    computed: {
        storeFormStatus() {

            let result = {}

            switch (this.storeStatus) {
                case 'success':
                    result = {
                        color: '#77de51',
                        text: this.$store.getters.t('facilities_store_form_status_sent')
                    }
                    break;
                case 'failed':
                    result = {
                        color: '#EE7372',
                        text: this.$store.getters.t('facilities_store_form_status_error')
                    }
                    break;
                default:
                    result = {
                        color: '#0674ec',
                        text: this.$store.getters.t('facilities_store_form_status_send')
                    }
            }

            return result

        },
    },

    methods: {
        storePost() {
            let self = this,
                url = (this.type === 'UPDATE' && Object.keys(this.updateOBJ).length) ?
                    `/api/homestays/${this.updateOBJ.id}?_method=PUT` : `/api/homestays`;

            self.$v.$touch();
            if (self.$v.storeForm.$invalid) {
                self.storeStatus = 'waiting_to_send';
                return false;
            }

            this.storeStatus = 'pending';

            let data = new FormData();

            data.append('city_id', self.storeForm.selectedCityId);
            data.append('street_address', self.storeForm.streetAddress);
            data.append('name', self.storeForm.title);
            data.append('description', self.storeForm.description);
            data.append('charge_category', self.storeForm.chargeCategory);
            data.append('reception_status', self.storeForm.receptionStatus);
            data.append('type', self.storeForm.type);
            data.append('view_mode', self.storeForm.viewMode);
            data.append('min_duration', self.storeForm.min_duration);

            if (self.type === "UPDATE" && self.storeForm.deleteImagesIds.length) {

                self.storeForm.deleteImagesIds.forEach(function (item) {
                    data.append('delete_images_ids[]', item);
                })

            }

            if (self.storeForm.max_duration) {
                data.append('max_duration', self.storeForm.max_duration);
            }
            self.storeForm.petCategories.forEach(function (item) {
                data.append('pet_categories[]', item);
            })
            if (self.storeForm.previewImagesOnlyBase64.length) {
                self.storeForm.previewImagesOnlyBase64.forEach(function (base64) {
                    let block = base64.split(";");
                    let contentType = block[0].split(":")[1];
                    let realData = block[1].split(",")[1];
                    let blob = self.b64toBlob(realData, contentType);
                    data.append('images[]', blob)
                });
            }


            axios({
                method: 'post',
                url: url,
                data: data,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {
                    response = response.data

                    if (response.success) {
                        self.storeStatus = 'success';
                        response = response.data

                        window.dataLayer = window.dataLayer || [];
                        dataLayer.push({
                            'event': 'shelter_help'
                        })

                        setTimeout(() => {
                            self.storeForm = {
                                citySearch: null,
                                citySelected: null,
                                selectedCityId: null,
                                cities: [],

                                viewMode: null,
                                type: null,
                                min_duration: 1,
                                max_duration: null,
                                streetAddress: null,
                                title: null,
                                description: null,
                                petCategories: [],
                                chargeCategory: null,
                                receptionStatus: null,


                                deleteImagesIds: [],
                                previewImagesOnlyBase64: [],
                                previewImages: [],
                                images: [],
                            }

                            self.$v.storeForm.$reset()
                            self.storeStatus = 'waiting_to_send';

                        }, 1000)


                    } else {
                        self.storeStatus = 'failed';

                        setTimeout(function () {
                            self.storeStatus = 'waiting_to_send';
                        }, 3000);
                    }

                })
                .catch(error => {
                    error = error.response.data

                    if (error) {
                        self.storeStatus = 'failed';
                        console.log(error)
                        alert(error.message)
                    }

                })
                .then(() => {

                    if ((this.type === 'UPDATE' && Object.keys(this.updateOBJ).length)) {
                        this.$emit('updateForm')
                        return
                    }

                    this.$emit('storeForm')

                })


        },
        b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            let byteCharacters = atob(b64Data);
            let byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                let slice = byteCharacters.slice(offset, offset + sliceSize);

                let byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                let byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            return new Blob(byteArrays, {type: contentType});
        },
        deleteServerPhoto(idx, idxServer) {

            this.storeForm.deleteImagesIds.push(idxServer)
            this.serverImages.splice(idx, 1)

        },
        deletePhoto(index) {
            let self = this;
            self.noReloadPreview = true;
            self.storeForm.previewImages.splice(index, 1);
            self.storeForm.images.splice(index, 1);
            self.storeForm.previewImagesOnlyBase64.splice(index, 1);
        },
        handleFileUpload(e) {
            let self = this;
            let files = e.target.files;
            self.storeForm.images = [];


            for (let key in files) {

                if (e.target.files[key] instanceof File) {
                    self.storeForm.images.push(e.target.files[key]);
                }

            }
        },
        searchCities(store = false) {
            let self = this;
            let url = '/' + self.appRoutes['geo.searchCities'],
                params = {
                    searchValue: self.citySearch
                }


            if (store) {
                params = {
                    searchValue: self.storeForm.citySearch
                }
            }

            axios.get(url, {params: params})
                .then(response => {
                    response = response.data;
                    if (response.success) {
                        if (store) {
                            return self.storeForm.cities = response.cities
                        }
                        self.cities = response.cities
                    } else {
                        alert(this.$store.getters.t('common_error_reload'));
                    }
                })
                .catch((error) => {

                })
                .then();
        },
        setStoreCityId(cityId, cityName) {
            this.storeForm.selectedCityId = cityId;
            this.storeForm.citySearch = cityName;
            this.storeForm.citySelected = cityName;
            this.storeForm.cities = [];
        },
        getPetsCategories() {
            let url = '/api/pets/categories'

            axios.get(url)
                .then(response => {
                    response = response.data

                    if (response.success) {
                        this.petsCategories = response.data
                    }

                })
                .catch(error => {
                    error = error.response.data
                    console.log(error)
                })
        },

    },

    validations: {
        storeForm: {
            selectedCityId: {
                required,
            },
            viewMode: {
                required
            },
            type: {
                required
            },
            min_duration: {
                required,
                numeric,
                minValue: minValue(1)
            },
            max_duration: {
                custom: function (value) {

                    if (value !== null && +value < +this.storeForm.min_duration) {

                        if (value === '') {
                            value = null
                            return true
                        }

                        return false
                    }


                    return true
                }
            },
            streetAddress: {
                required,
                maxLength: maxLength(256)
            },
            title: {
                required,
                maxLength: maxLength(256)
            },
            description: {
                required,
                minLength: minLength(30),
                maxLength: maxLength(1000)
            },
            chargeCategory: {
                required
            },
            receptionStatus: {
                required
            },
            petCategories: {
                required
            }
        }
    },


}
</script>

<style lang="scss" scoped>


.homestay {

    &__item {
        .card-horizontal__user-photo span {
            background: #2E76E4;
        }
    }


}


</style>
